module.exports = __webpack_public_path__ + "static/media/lk_photo_templo_gangaramaya.b4dec7b1.jpg";